import { Dialog } from 'primereact/dialog'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import LoadingIndicator from '../../LoadingIndicator'
import { resolveNocRequired } from '../../../services/csnDashboardService'
import getPrincipal from '../../../utils/getPrincipal'
import getPLACIUser from '../../../utils/getPLACIUser'
import warningIcon from '../../../assets/images/warning_filled.svg'
import { PrimaryButton, SecondaryButton } from '../../../common/Buttons'
import './resolve-missing-hawb-popup.scss'


const ResolveNocRequiredPopup = ({
	resolveNocRequiredPopup,
	setResolveNocRequiredPopup ,
	flightData,
	setShowLoader,
	setAlertMessage,
	setStatus,
}) => {
	const { t } = useTranslation(['labels'])
	const [isLoading, setIsLoading] = useState(false);


	const handleNo = () => {
		setResolveNocRequiredPopup({
			isOpen: false,
			awbNumber: null,
			type: null
		})
	}

	const handleYes = async () => {

		try {
			setShowLoader(true)
			const principal = getPrincipal()
			const placiUser = getPLACIUser()

			const reqObj = {
				userId:  principal?.sub,
				userStation: placiUser?.stationCode ? placiUser?.stationCode : null,
				awbNumber: resolveNocRequiredPopup.awbNumber,
				flightId: flightData.flightId,
				userType: principal?.type,
				type: resolveNocRequiredPopup.type

			}
			const response = await resolveNocRequired(reqObj)
			if (response && response.status === 200) {
				setAlertMessage(`NOC Required status for ${resolveNocRequiredPopup.type} successfully resolved for AWB ${resolveNocRequiredPopup.awbNumber}.`)
				setStatus(true)
			} else {
				setAlertMessage(`NOC Required status for ${resolveNocRequiredPopup.type} could not be resolved for AWB ${resolveNocRequiredPopup.awbNumber}.`)
				setStatus(false)
			}
		} catch (error) {
			setAlertMessage(`NOC Required status for ${resolveNocRequiredPopup.type} could not be resolved for AWB ${resolveNocRequiredPopup.awbNumber}.`)
			setStatus(false)
		} finally {
			setShowLoader(false)
			setResolveNocRequiredPopup({
				isOpen: false,
				awbNumber: null,
				type: null
			})
			window.scrollTo(0, 0)
		}

	}

	const RenderFooter = () => {
		return (
			<div className='footer'>
                <SecondaryButton label={t('COMMON.YES')} onClick={handleYes} />
                <PrimaryButton label={t('COMMON.NO')} onClick={handleNo} />
            </div>
		)
	}

	return (
		<div className='cargo-portal-container dialog-container resolve-missing-hawb-dialog'>
			<div className='portal-dialog p-fluid'>
				<Dialog
					footer={<RenderFooter />}
					visible
					modal
					closable={true}
					header=''
					onHide={handleNo}
				>
					<div className='warning-icon-container'>
						<img src={warningIcon} alt='Warning' />
					</div>
					<h3 className='mt-1 mb-4 dialog-header'>Resolve NOC Required?</h3>
					<div className='inner-container'>
						<p className='mt-2 dialog-message'>
							Do you want to resolve the NOC required for the MAWB {resolveNocRequiredPopup.awbNumber}?
						</p>
					</div>
				</Dialog>
			</div>
			{isLoading && <LoadingIndicator />}
		</div>
	)
}

export default ResolveNocRequiredPopup
